module.exports = __webpack_public_path__ + "static/media/duke_of_weselton.de5c8aba.jpg";